import React from 'react';
import { Card, Grid, NumberInput, RadioList, TextInput } from 'ui-toolkit';
import { ISummaryData } from '../../../ui-toolkit/orders/interfaces/titleReport/ISummary';
import { eTitleEvidenceFeeType } from '../../../ui-toolkit/orders/interfaces/titleReport/eTitleEvidenceFeeType';
import { isNil } from 'lodash';

interface ITitleEvidenceProps {
  data: ISummaryData;
  titleEvidenceFeeType: eTitleEvidenceFeeType;
  error?: any;
  title?: string;
  validateFormData: (path: string) => void;
  onFormChange: (dataPath: string, newData: any, error?: string | null | undefined) => void;
}
export const TitleEvidence: React.FC<ITitleEvidenceProps> = ({
  data,
  title,
  titleEvidenceFeeType,
  error,
  onFormChange,
  validateFormData,
}) => {
  const options = (selectedFeeType: eTitleEvidenceFeeType) => [
    {
      label: (
        <NumberInput
          value={data.titleEvidenceFee}
          onChange={(value, error) => onFormChange('summary.titleEvidenceFee', value, error)}
          placeholder="0.00"
          prefix="$"
          mode="currency"
          allowNegative={false}
          readOnly={selectedFeeType !== eTitleEvidenceFeeType.fee}
        />
      ),
      value: eTitleEvidenceFeeType.fee,
    },
    {
      label: (
        <NumberInput
          value={data.titleEvidencePercent}
          onChange={(value, error) => onFormChange('summary.titleEvidencePercent', value, error)}
          errorText={error['summary.titleEvidencePercent']}
          placeholder="00"
          suffix="%"
          allowNegative={false}
          readOnly={selectedFeeType !== eTitleEvidenceFeeType.percentage}
        />
      ),
      value: eTitleEvidenceFeeType.percentage,
    },
  ];
  return (
    <Card title={title || 'Title Evidence'}>
      <Grid templateColumns="1fr 2fr 1fr">
        <TextInput
          value={data.titleEvidenceAgent}
          isRequired
          errorText={error['summary.titleEvidenceAgent']}
          onChange={(value, error) => onFormChange('summary.titleEvidenceAgent', value, error)}
          placeholder="Duck Newton"
          label="Title Evidence Agent"
        />
        <RadioList
          value={titleEvidenceFeeType}
          onChange={(event) => {
            onFormChange('titleEvidenceFeeType', event.target.value);
            if (event.target.value === eTitleEvidenceFeeType.fee && data.titleEvidencePercent) {
              onFormChange('summary.titleEvidencePercent', undefined);
            } else if (event.target.value === eTitleEvidenceFeeType.percentage && !isNil(data.titleEvidenceFee)) {
              onFormChange('summary.titleEvidenceFee', undefined);
            }
            validateFormData('titleEvidenceFeeType');
          }}
          errorText={error['summary.titleEvidenceFee']}
          label="Title Evidence Fee"
          orientation={'horizontal'}
          name="feeType"
          options={options(titleEvidenceFeeType)}
          isRequired
        />
      </Grid>
    </Card>
  );
};
